import { createAsyncThunk } from '@reduxjs/toolkit';
import { HomepageContent } from '@wix/wix-help-widget-common/homepage';

import { getHomepageContent } from '../../homepage/api';
import { widgetSDK } from '../../sdk/widgetSDK';
import { fedopsLogger } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

export const loadHomepageContent = createAsyncThunk<HomepageContent, HttpClientFactory>(
  'loadHomepageContent',
  async (httpClient: HttpClientFactory) => {
    fedopsLogger.interactionStarted('fetching-homepage-content');

    const context = await widgetSDK.getContext();
    const { parentUrl, userExperience } = context;
    const homepageContent = await getHomepageContent(httpClient, parentUrl, userExperience);

    fedopsLogger.interactionEnded('fetching-homepage-content');
    return homepageContent;
  },
);
